<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import report_raeiAPI from "@/services/standards/report_raeiAPI/report_raeiAPI.js";
import raeiReportAPI from "@/services/standards/raeiReport/raeiReportAPI.js";
import newScoresAPI from "../../../../services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import DocumentActions from "@/components/document/DocumentActions.vue";

/**
 * 3.2.3 Registro y análisis estadístico de Incidentes, AT y EL (RAEI).
 * Reporte anual (selector de año) DERIVADO de accident_reports + accident_investigations:
 * KPIs + gráfica mensual + Excel del año + PDF branded firmable.
 */
export default {
  page: {
    title: "3.2.3 Registro y análisis estadístico",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Style, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "3.2.3 Registro y análisis estadístico de incidentes, accidentes de trabajo y enfermedades laborales",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "Registro y análisis estadístico", active: true },
      ],
      chartData: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        series: [[], [], []],
      },
      chartOptions: { lineSmooth: false },
      loading1: true,
      itemStatus: "No cumplido",
      item: null,
      itemData: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      // Reporte estadístico anual (firmable)
      raeiYear: new Date().getFullYear(),
      raeiData: null,
      raeiStatus: "draft",
      raeiSignedAt: null,
    };
  },
  computed: {
    raeiYears() {
      const y = new Date().getFullYear();
      return Array.from({ length: 6 }, (_, i) => y - i);
    },
    raeiSigned() {
      return this.raeiStatus === "signed";
    },
    raeiApi() {
      return {
        pdfUrl: (year) => raeiReportAPI.pdfUrl(this.companyID, year),
        sign: (year, payload) => raeiReportAPI.sign(this.companyID, year, payload),
      };
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(34).then((r) => { this.itemData = r; }).catch((e) => console.log(e));
    },
    allowAccess() {
      try {
        const item = this.itemData;
        if (!item) return false;
        const c = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (c === 1 && item.obligatory_UPA === 1) return true;
        if (c === 2 && item.obligatory_groupI === 1) return true;
        if (c === 3 && item.obligatory_groupII === 1) return true;
        if (c === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (e) { console.log(e); return false; }
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (!role) return false;
      if (roles) role = roles.includes(role);
      else role = [1, 2, 3, 4, 5, 6, 7, 8].includes(role);
      const permissions = this.$store.state.auth.info.permissions;
      const enabled = permissions.find((p) => p.name === name);
      return enabled && role ? true : false;
    },
    dateConvert(date) { return dateFormat(date); },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 34)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
          this.loading1 = false;
        })
        .catch((e) => { console.log(e); this.loading1 = false; });
    },
    changeItemStatus(itemStatus) {
      newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 34, status: itemStatus })
        .then(() => {
          Swal.fire({ title: "¡Éxito!", text: "¡Estado del ítem actualizado!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" });
          setTimeout(() => window.location.reload(), 1500);
        })
        .catch((e) => { Swal.fire({ title: "¡ERROR!", text: "¡No se actualizó el estado!", icon: "error" }); console.log(e); });
    },

    // ── Reporte estadístico anual (firmable) ──
    loadRaei() {
      raeiReportAPI.data(this.companyID, this.raeiYear)
        .then((r) => {
          if (!r) return;
          this.raeiData = r;
          this.raeiStatus = r.workflow_status || "draft";
          this.raeiSignedAt = r.signed_at || null;
          const months = r.months || [];
          this.chartData = {
            labels: this.chartData.labels,
            series: [
              months.map((m) => m.at),
              months.map((m) => m.it),
              months.map((m) => m.el),
            ],
          };
        })
        .catch((e) => console.log(e));
    },
    downloadExcel() {
      const url = report_raeiAPI.getExcel(this.companyID, `${this.raeiYear}-01-01`, `${this.raeiYear}-12-31`);
      window.location.href = url;
    },
    downloadRaeiPdf() {
      window.open(raeiReportAPI.pdfUrl(this.companyID, this.raeiYear), "_blank");
    },
    onRaeiSigned(payload) {
      this.raeiStatus = payload.workflow_status;
      this.raeiSignedAt = payload.signed_at;
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.loadRaei();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe llevar el registro estadístico de los accidentes de trabajo, incidentes y
                      enfermedades laborales. Selecciona el año para consultar los indicadores (frecuencia, severidad y
                      cobertura de investigación), visualizar la tendencia mensual, descargar el reporte en Excel y
                      generar el reporte estadístico para su firma.
                    </p>
                  </CheckModal>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <!-- Reporte estadístico anual (firmable) -->
              <div class="card border">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="d-flex align-items-center mb-2">
                        <h5 class="mb-0 mr-3">Reporte estadístico anual</h5>
                        <b-form-select v-model="raeiYear" @change="loadRaei" style="max-width:140px;" size="sm">
                          <b-form-select-option v-for="y in raeiYears" :key="y" :value="y">{{ y }}</b-form-select-option>
                        </b-form-select>
                      </div>
                      <div v-if="raeiData" class="mb-2">
                        <div class="mb-1">
                          <span class="badge badge-primary mr-1">Accidentes: {{ raeiData.totals.at }}</span>
                          <span class="badge badge-info mr-1">Incidentes: {{ raeiData.totals.it }}</span>
                          <span class="badge badge-secondary mr-1">Enf. laborales: {{ raeiData.totals.el }}</span>
                          <span class="badge badge-danger mr-1">Días perdidos: {{ raeiData.totals.dias }}</span>
                        </div>
                        <div class="small text-muted">
                          Leves: {{ raeiData.sub.Leves }} · Graves: {{ raeiData.sub.Graves }} · Mortales: {{ raeiData.sub.Mortales }}
                          &nbsp;|&nbsp; N° colaboradores: {{ raeiData.employees }}
                        </div>
                        <div class="small mt-1">
                          <span class="mr-2">Í. Frecuencia AT: <strong>{{ raeiData.totals.frecuencia }}</strong></span>
                          <span class="mr-2">Í. Severidad: <strong>{{ raeiData.totals.severidad }}</strong></span>
                          <span>Cobertura inv.: <strong>{{ raeiData.totals.cobertura === null ? '—' : (raeiData.totals.cobertura * 100).toFixed(0) + '%' }}</strong></span>
                        </div>
                      </div>
                      <div>
                        <button type="button" class="btn btn-outline-primary btn-sm mr-1" :disabled="!allowAccess()" @click="downloadRaeiPdf">
                          <i class="mdi mdi-file-pdf-box"></i> Descargar PDF branded
                        </button>
                        <button type="button" class="btn btn-light btn-sm" :disabled="!allowAccess()" @click="downloadExcel">
                          <i class="bx bx-download"></i> Descargar Excel
                        </button>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <DocumentActions
                        :document-id="Number(raeiYear)"
                        :company-id="companyID"
                        :workflow-status="raeiStatus"
                        :signed-at="raeiSignedAt"
                        :api-service="raeiApi"
                        document-title="Reporte Estadístico de Incidentes, AT y EL"
                        signer-role="gerente"
                        @signed="onRaeiSigned"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tendencia mensual del año -->
              <div class="card">
                <div class="card-body" dir="ltr">
                  <h4 class="header-title">Tendencia mensual {{ raeiYear }}</h4>
                  <div class="d-flex flex-wrap mb-2" style="gap:18px;">
                    <span class="d-inline-flex align-items-center small">
                      <span class="raei-legend" style="background:#f1556c;"></span> Accidentes de trabajo
                    </span>
                    <span class="d-inline-flex align-items-center small">
                      <span class="raei-legend" style="background:#f7b84b;"></span> Incidentes
                    </span>
                    <span class="d-inline-flex align-items-center small">
                      <span class="raei-legend" style="background:#4fc6e1;"></span> Enfermedades laborales
                    </span>
                  </div>
                  <div class="raei-chart">
                    <Chartist ratio="ct-chart" :data="chartData" :options="chartOptions" type="Line"></Chartist>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
.raei-legend {
  display: inline-block;
  width: 22px;
  height: 4px;
  border-radius: 2px;
  margin-right: 6px;
}
</style>

<!-- Colores fijos de las 3 series (no-scoped, acotado a .raei-chart para no afectar otras gráficas).
     Deben coincidir con la leyenda: A=Accidentes (rojo), B=Incidentes (ámbar), C=EL (azul). -->
<style>
.raei-chart .ct-series-a .ct-line,
.raei-chart .ct-series-a .ct-point { stroke: #f1556c !important; }
.raei-chart .ct-series-b .ct-line,
.raei-chart .ct-series-b .ct-point { stroke: #f7b84b !important; }
.raei-chart .ct-series-c .ct-line,
.raei-chart .ct-series-c .ct-point { stroke: #4fc6e1 !important; }
</style>
